import {
    UNITTYPE_DELETE_OPEN_MODAL,
    UNITTYPE_DELETE_REQUEST,
    UNITTYPE_DELETE_RESULT,
} from 'Redux/actionTypes';

export const unitTypeDeleteOpenModal = (data) => ({
    type: UNITTYPE_DELETE_OPEN_MODAL,
    payload: data,
})

export const unitTypeRequest = (data) => ({
    type: UNITTYPE_DELETE_REQUEST,
    payload: data,
})

export const unitTypeResult = (result) => ({
    type: UNITTYPE_DELETE_RESULT,
    payload: result
})